// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oj-0";